import {
  resolveOriginalSrcForFailedGumletImage,
  forgetGumletImageFallbackMapping,
} from '~/utils/gumletUtils'

/**
 * If Gumlet does not successfully load an image (non-2xx, network error, corrupt body, etc.),
 * swap `<img>` to the Strapi/S3 URL we rewrote from — see `registerGumletImageRewriteForFallback`.
 */
export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  if (config.public.gumletEnabled !== true) { return }
  if (config.public.gumletImageErrorFallback === false) { return }

  const gumletHost = String(config.public.gumletHost || '')
    .replace(/^https?:\/\//i, '')
    .replace(/\/$/, '')
    .toLowerCase()
  if (!gumletHost) { return }

  document.addEventListener(
    'error',
    (event) => {
      const target = event.target
      if (!(target instanceof HTMLImageElement)) { return }
      if (target.getAttribute('data-gumlet-img-fallback') === '1') { return }

      const failed = target.currentSrc || target.src || ''
      if (!failed) { return }

      let host: string
      try {
        host = new URL(failed, location.href).hostname.toLowerCase()
      } catch {
        return
      }
      if (host !== gumletHost) { return }

      const original = resolveOriginalSrcForFailedGumletImage(failed)
      if (!original) { return }

      target.setAttribute('data-gumlet-img-fallback', '1')
      target.removeAttribute('srcset')
      target.removeAttribute('sizes')
      target.src = original
      forgetGumletImageFallbackMapping(failed)
    },
    true,
  )
})
